import React, { useEffect, useState } from 'react';
import { Star, Quote, ChevronLeft, ChevronRight } from 'lucide-react';
import { testimonials } from '../mock';
import useReveal from '../hooks/useReveal';

const Testimonials = () => {
  useReveal();
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((p) => (p + 1) % testimonials.length), 6500);
    return () => clearInterval(t);
  }, []);

  return (
    <section className="py-16 lg:py-24" style={{ background: 'linear-gradient(180deg, #F7F4EA 0%, #E9D6C1 100%)' }}>
      <div className="max-w-5xl mx-auto px-6 lg:px-10 text-center">
        <div className="reveal text-[11px] uppercase tracking-[0.32em] font-semibold text-[#F58220] mb-4">
          Our Testimonial
        </div>
        <h2 className="reveal h-display uppercase text-[40px] md:text-[64px] text-[#1a1410]">
          What our <span className="text-[#F58220]">customers</span> say
        </h2>

        <div className="reveal relative mt-16">
          <Quote className="absolute -top-6 left-1/2 -translate-x-1/2 w-14 h-14 text-[#F58220]/30" strokeWidth={1.2} />

          <div className="min-h-[280px] relative">
            {testimonials.map((it, i) => (
              <div
                key={it.id}
                className={`absolute inset-0 transition-all duration-700 ease-out ${
                  i === idx ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
                }`}
              >
                <div className="flex justify-center gap-1 mb-7">
                  {[...Array(it.rating)].map((_, k) => (
                    <Star key={k} className="w-4 h-4 fill-[#F58220] text-[#F58220]" />
                  ))}
                </div>
                <p className="font-body text-[20px] md:text-[26px] leading-[1.55] text-[#1a1410] max-w-3xl mx-auto">
                  “{it.text}”
                </p>
                <div className="mt-9">
                  <div className="h-display uppercase text-[16px] text-[#1a1410]">{it.name}</div>
                  <div className="text-[10px] uppercase tracking-[0.26em] font-semibold text-[#F58220] mt-1">
                    {it.city}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 flex items-center justify-center gap-5">
            <button
              onClick={() => setIdx((idx - 1 + testimonials.length) % testimonials.length)}
              className="w-11 h-11 rounded-full border border-[#4D4D4D]/30 bg-white flex items-center justify-center hover:bg-[#F58220] hover:text-white hover:border-[#F58220] transition-all duration-400"
              aria-label="previous"
            >
              <ChevronLeft className="w-4 h-4" />
            </button>
            <div className="flex gap-2">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setIdx(i)}
                  className={`h-[3px] rounded-full transition-all duration-500 ${
                    i === idx ? 'w-10 bg-[#F58220]' : 'w-5 bg-[#8E8E8E]/40'
                  }`}
                />
              ))}
            </div>
            <button
              onClick={() => setIdx((idx + 1) % testimonials.length)}
              className="w-11 h-11 rounded-full border border-[#4D4D4D]/30 bg-white flex items-center justify-center hover:bg-[#F58220] hover:text-white hover:border-[#F58220] transition-all duration-400"
              aria-label="next"
            >
              <ChevronRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
